import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { passengerCMSApi } from "~/Services";

interface DocumentDetailsResponse {
  id: string;
  name: string;
  parent_term_name: string;
  parent_term_id: string;
  title_malay: string;
  title_mandarin: string;
  published: boolean;
}

// edit api call
const fetchChildAirportDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await passengerCMSApi.get(`/api/get-airport-category-crud-api-data/${id}`);
  console.log(response.data.data, "testtttt");
  return response?.data.data;
};

const useChildAirportDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["levelDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchChildAirportDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useChildAirportDocumentDetails };
